import React from "react";
import './MiniBar.scss'
import {FormatListBulleted} from "@mui/icons-material";
import {Link} from "react-router-dom";

const MiniBar = () => {


    return (
        <div className={'miniBarContainer'}>
            <div>
                <input type="checkbox" id={'check'}/>
                <label htmlFor="check">
                    <div>
                        <FormatListBulleted className={'bullet'}/>
                    </div>
                </label>
                <ul className={'miniMenu'}>
                  <li className={'miniHint'}>Hello visitor, welcome, please click the images below to know more</li>
                    <li className={'miniNavigation'}><Link to={'/about'}>About</Link></li>
                    <li className={'miniNavigation'}><Link to={'/experience'}>Experience</Link></li>
                    <li className={'miniNavigation'}><Link to={'/contact'}>Contact</Link></li>
                </ul>


            </div>
        </div>
    )

}


export default MiniBar
